import { api } from '@src/api/api'
import { SubscriptionsType } from '@src/store/ducks/subscriptions/types'

export const subscriptionsApi = {
  getSubscriptions(accountId: number) {
    return api.get<SubscriptionsType[]>('/v1/user/check-available-subscriptions', { accountId })
  },
  addSubscriptions(accountId: number, goodId: string) {
    return api.post<string>('/v1/user/add-subscriptions', { accountId, goodId })
  },
  closeSubscriptions(serviceId: number) {
    return api.del<string>('/v1/user/close-subscriptions', { serviceId })
  },
}
